export default __webpack_public_path__ + "static/media/330_dummy2016-irishpub01-mobile-de.554c0fb2.png";